module.exports = __webpack_public_path__ + "static/media/organisation-d-un-atelier-de-dialogue-public-pour-le-projet-SIENNA-mini.f1b31410.jpg";